import { createApp } from "vue";
import VueApexCharts from "vue3-apexcharts";
import VueToast from "vue-toast-notification";

import App from "./App.vue";
import router from "./router";
import store from "./store";

import Modal from "@/components/global/Modal.vue";

import "vue-toast-notification/dist/theme-sugar.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";


const app = createApp(App);

app.use(router);
app.use(store);
app.use(VueToast, { position: "top-right" });

app.component("apexchart", VueApexCharts);
app.component("Modal", Modal);

router.isReady().then(() => {
  app.mount("#app");
});
